import { useNavigate } from "react-router-dom";
import { useBranchModal } from "@/contexts/BranchModalContext";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import OrderTypeStep from "./OrderTypeStep";
import PickupBranchStep from "./PickupBranchStep";
import DeliveryMapStep from "./DeliveryMapStep";

export default function BranchModal() {
  const { isOpen, step, closeBranchModal, onCompleteRef, onCloseRef  } = useBranchModal();
  const navigate = useNavigate();

 const handleClose = () => {
    const hasCustomClose = !!onCloseRef.current;
    closeBranchModal();
    if (!hasCustomClose) {
      navigate("/");
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && handleClose()}>
      <DialogContent className="max-w-lg p-0 gap-0 overflow-hidden max-h-[90vh] flex flex-col">
        {step === "order-type" && <OrderTypeStep />}
        {step === "pickup-branch" && <PickupBranchStep />}
        {step === "delivery-map" && <DeliveryMapStep  />}
      </DialogContent>
    </Dialog>
  );
}
